export const config = {
	textField: {
		hideDetails: true,
		class: 'ma-3'
	},
	rangeSlider: {
		hideDetails: true,
		class: 'align-center mt-2 mb-6'
	}
};
